import React from 'react';
import { v4 as uuid } from 'uuid';
import {
  getChords,
  getContentImage,
  getContentText,
  getLessonsMessage,
  getLevelDisplay,
  getTitle,
  getContentTitle,
} from './CurriculumContent';
import Link from '../Link';

function getRowContent(items, rowInfo, isSearch) {
  const { display, height, itemHeightStyle } = rowInfo;
  return items.map(item => (
    <Link
      className="flex flex-row black"
      data-id={`curriculum-row-${item.title}`}
      key={uuid()}
      to={item.url}
      trackEvent={item.trackEvent || null}
    >
      <div className={`black db w-40 pr2 source-sans ttc ${itemHeightStyle}`}>
        {getContentTitle(item.title, isSearch)}
      </div>
      <div
        className={`flex justify-between items-start tl pb0 ${display.title ? 'w-100' : 'w-60'}`}
      >
        {getChords(
          display.chords,
          item.chords,
          `db tl w-60 ${itemHeightStyle}`,
          'flex flex-columns',
        )}
        {getContentText(display.type, item.type, `${itemHeightStyle} ttc pl5`)}
        {getContentText(display.description, item.description, `${itemHeightStyle} source-sans`)}
        {getContentText(display.lessons, getLessonsMessage(item.lessons), `${itemHeightStyle} pl5`)}
        {getContentText(
          display.minutes && item.minutes,
          `${item.minutes} minutes`,
          `gray ${itemHeightStyle} w-30`,
        )}
        {getLevelDisplay(display.level, item.level, `${height} flex items-center`)}
      </div>
    </Link>
  ));
}

const CurriculumLarge = (content, display, styleObj) => {
  const { height } = styleObj;
  const itemHeightStyle = `${height} flex items-center`;
  const style = `w-40 pr3 ${itemHeightStyle}`;

  return content.map((rowContent, index) => {
    const { items, title, url, trackEvent, isSearch, type } = rowContent;
    return (
      <div
        className={`flex items-center bb ${index === 0 ? 'pb2' : 'pv2'} b--light-gray`}
        key={`curriculum-large-${type || ''}-${url}`}
      >
        <div className="flex w-100">
          {getContentImage(rowContent, styleObj)}
          <div className="flex-auto flex items-start">
            {getTitle({ title, url, trackEvent, style, isSearch })}
            <div className="w-100 f6">
              {getRowContent(items, { display, height, itemHeightStyle }, isSearch)}
            </div>
          </div>
        </div>
      </div>
    );
  });
};
export default CurriculumLarge;
